// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { readFromLocalStorage } from "./utils/DataEncryption";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        DealerLocator: "Dealer Locator",
        EnterALocation: "Enter a Location",
        DetectLocation: "Detect Location",
        DealerDetails: "Dealer Details",
        Location: "Location",
        Locations: "Locations",
        SeeAll: "See All",
        GetDirections: "Get Directions",
        EnableYourLocation: "Enable Your Location",
        AllowToDetect: "Allow us to detect your location to provide nearby dealer details instantly",
        Allow: "Allow",
        Block: "Block",
        SelectCity: "Select City",
        SelectProvince: "Select Province",
        subcategories: {
          "Sales": "Sales",
          "Service": "Service",
          "Spares": "Spares",
          "Authorised parts stockist": "Authorised parts stockist",
          "Apache RR310": "Apache RR310",
          "Apache RTR310": "Apache RTR310",
          "TVS Ronin": "TVS Ronin",
          "TVS iQube": "TVS iQube",
          "TVS X": "TVS X",
          "Two Wheeler": "Two Wheeler",
          "Three Wheeler": "Three Wheeler",
          "Super Premium": "Super Premium",
          "Electric": "Electric"
        },
        Filters: "Filters",
        ClearFilters: "Clear Filters",
        DealerType: "Dealer Type",
        OutletSelection: "Outlet Selection",
      }
    },

// Spanish Translation for Argentina nad Mexico
    es: {
  translation: {
    DealerLocator: "Localizador de Concesionarios",
    EnterALocation: "Ingresar una Ubicación",
    DetectLocation: "Detectar Ubicación",
    DealerDetails: "Detalles del Concesionario",
    Location: "Ubicación",
    Locations: "Ubicaciones",
    SeeAll: "Ver Todos",
    GetDirections: "Obtener Indicaciones",
    subcategories: {
      "Sales": "Ventas",
      "Service": "Servicio",
      "Spares": "Repuestos",
      "Two Wheeler": "Vehículo de Dos Ruedas",
      "Three Wheeler": "Vehículo de Tres Ruedas",
      "Electric": "Eléctrico"
    },
    Filters: "Filtros",
    ClearFilters: "Borrar Filtros",
    DealerType: "Tipo de Concesionario",
    OutletSelection: "Selección de Sucursal"
  }
},
 

    // ITALIAN TRANSLATIONS
    it: {
      translation: {
        DealerLocator: "Trova Concessionario",
        EnterALocation: "Inserisci una località",
        DetectLocation: "Rileva posizione",
        DealerDetails: "Dettagli concessionario",
        Location: "Località",
        Locations: "Località",
        SeeAll: "Vedi tutto",
        GetDirections: "Ottieni indicazioni",
        EnableYourLocation: "Attiva la tua posizione",
        AllowToDetect: "Permettici di rilevare la tua posizione per mostrarti i Concessionari più vicini",
        Allow: "Consenti",
        Block: "Blocca",
        subcategories: {
          "Sales": "Vendite",
          "Service": "Servizio",
          "Spares": "Ricambi",
          "Authorised parts stockist": "Rivenditore autorizzato di ricambi",
          "Apache RR310": "Apache RR310",
          "Apache RTR310": "Apache RTR310",
          "TVS Ronin": "TVS Ronin",
          "TVS iQube": "TVS iQube",
          "TVS X": "TVS X",
          "Two Wheeler": "Due ruote",
          "Three Wheeler": "Tre ruote",
          "Super Premium": "Super Premium",
          "Electric": "Elettrico"
        },
        Filters: "Filtri",
        ClearFilters: "Cancella filtri",
        DealerType: "Tipo di concessionario",
        OutletSelection: "Selezione punto vendita",
      }
    },

    // TURKISH TRANSLATIONS
    tr: {
      translation: {
        DealerLocator: "Bayi Bulucu",
        EnterALocation: "Konum Girin",
        DetectLocation: "Konumu Algıla",
        DealerDetails: "Bayi Detayları",
        Location: "Konum",
        Locations: "Konumlar",
        SeeAll: "Tümünü Gör",
        GetDirections: "Yol Tarifi Al",
        subcategories: {
          "Sales": "Satış",
          "Service": "Servis",
          "Spares": "Yedek Parçalar",
          "Two Wheeler": "İki Tekerlekli",
          "Three Wheeler": "Üç Tekerlekli",
          "Electric": "Elektrikli"
        },
        Filters: "Filtreler",
        ClearFilters: "Filtreleri Temizle",
        DealerType: "Bayi Türü",
        OutletSelection: "Şube Seçimi",
      }
    },


// NEPALI TRANSLATIONS
    ne: {
      translation: {
        DealerLocator: "डिलर लोकेटर",
        EnterALocation: "स्थान प्रविष्ट गर्नुहोस्",
        DetectLocation: "स्थान पहिचान गर्नुहोस्",
        DealerDetails: "डिलर विवरण",
        Location: "स्थान",
        Locations: "स्थानहरू",
        SeeAll: "सबै हेर्नुहोस्",
        GetDirections: "दिशानिर्देश प्राप्त गर्नुहोस्",

        subcategories: {
          "Sales": "बिक्री",
          "Service": "सेवा",
          "Spares": "स्पेयर पार्ट्स",
          "Two Wheeler": "दुई पांग्रे",
          "Three Wheeler": "तीन पांग्रे",
          "Electric": "इलेक्ट्रिक"
        },

        Filters: "फिल्टरहरू",
        ClearFilters: "फिल्टरहरू हटाउनुहोस्",
        DealerType: "डिलर प्रकार",
        OutletSelection: "आउटलेट छनौट",
      }
    },
    // ARABIC TRANSLATIONS
    ar: {
      translation: {
        DealerLocator: "محدد مواقع الوكلاء",
        EnterALocation: "أدخل موقعًا",
        DetectLocation: "تحديد الموقع تلقائيًا",
        DealerDetails: "تفاصيل الوكيل",
        Location: "الموقع",
        Locations: "المواقع",
        SeeAll: "عرض الكل",
        GetDirections: "الحصول على الاتجاهات",
        subcategories: {
          "Sales": "المبيعات",
          "Service": "الخدمة",
          "Spares": "قطع الغيار",
          "Two Wheeler": "مركبة ذات عجلتين",
          "Three Wheeler": "مركبة ذات ثلاث عجلات",
          "Electric": "كهربائي"
        },
        Filters: "عوامل التصفية",
        ClearFilters: "مسح عوامل التصفية",
        DealerType: "نوع الوكيل",
        OutletSelection: "اختيار المنفذ"
      }
    },
    sw: {
      translation: {
        DealerLocator: "Kipata Wakala",
        EnterALocation: "Ingiza Mahali",
        DetectLocation: "Gundua Mahali",
        DealerDetails: "Maelezo ya Wakala",
        Location: "Mahali",
        Locations: "Maeneo",
        SeeAll: "Tazama Zote",
        GetDirections: "Pata Maelekezo",
        subcategories: {
          "Sales": "Mauzo",
          "Service": "Huduma",
          "Spares": "Vipuri",
          "Two Wheeler": "Pikipiki",
          "Three Wheeler": "Bajaji",
          "Electric": "Umeme"
        },
        Filters: "Vichujio",
        ClearFilters: "Futa Vichujio",
        DealerType: "Aina ya Wakala",
        OutletSelection: "Uchaguzi wa Tawi"
      }
    },
    id: {
      translation: {
        DealerLocator: "Pencari Dealer",
        EnterALocation: "Masukkan Lokasi",
        DetectLocation: "Deteksi Lokasi",
        DealerDetails: "Detail Dealer",
        Location: "Lokasi",
        Locations: "Lokasi",
        SeeAll: "Lihat Semua",
        GetDirections: "Dapatkan Petunjuk Arah",
        subcategories: {
          "Sales": "Penjualan",
          "Service": "Servis",
          "Spares": "Suku Cadang",
          "Two Wheeler": "Kendaraan Roda Dua",
          "Three Wheeler": "Kendaraan Roda Tiga",
          "Electric": "Listrik"
        },
        Filters: "Filter",
        ClearFilters: "Hapus Filter",
        DealerType: "Jenis Dealer",
        OutletSelection: "Pilihan Outlet"
      }
    },
    bn: {
      translation: {
        DealerLocator: "ডিলার লোকেটর",
        EnterALocation: "একটি অবস্থান লিখুন",
        DetectLocation: "অবস্থান সনাক্ত করুন",
        DealerDetails: "ডিলারের বিবরণ",
        Location: "অবস্থান",
        Locations: "অবস্থানসমূহ",
        SeeAll: "সব দেখুন",
        GetDirections: "দিকনির্দেশ পান",
        subcategories: {
          "Two Wheeler": "দুই চাকার যান",
          "Three Wheeler": "তিন চাকার যান",
          "Electric": "বৈদ্যুতিক",
          "Sales": "বিক্রয়",
          "Service": "পরিষেবা",
          "Spares": "যন্ত্রাংশ",
         },
        Filters: "ফিল্টারসমূহ",
        ClearFilters: "ফিল্টার মুছুন",
        DealerType: "ডিলারের ধরন",
        OutletSelection: "আউটলেট নির্বাচন"
      }
    }
    
  },
  lng: readFromLocalStorage("locale"), // default language
  fallbackLng: "en",
  interpolation: { escapeValue: false }
});

export default i18n;

